export default __webpack_public_path__ + "static/media/22_MestMarzipan-Commercial-EschweilerPhotography_21A0484.9f25e813.jpg";